
// import RootLayout from "../pages/RootLayout";
import { Navigate } from "react-router-dom";
import ErrorPage from "../pages/docs/Error";
import GetStartedPage from "../pages/docs/GetStartedPage";
import LayoutStructurePage from "../pages/docs/layout/LayoutStructurePage";
import StackPage from "../pages/docs/layout/StackPage";
import ContainerPage from "../pages/docs/layout/ContainerPage";
import AccordionPage from "../pages/docs/component/AccordionPage";
import AlertPage from "../pages/docs/component/AlertPage";
import BadgePage from "../pages/docs/component/BadgePage";
import ListGroupPage from "../pages/docs/component/ListGroupPage";
import BreadcrumbPage from "../pages/docs/component/BreadcrumbPage";
import ButtonPage from "../pages/docs/component/ButtonPage";
import ButtonGroupPage from "../pages/docs/component/ButtonGroupPage";
import CardPage from "../pages/docs/component/CardPage";
import GridPage from "../pages/docs/layout/GridPage";
import DropdownPage from "../pages/docs/component/DropdownPage";
import ModalPage from "../pages/docs/component/ModalPage";
import NavPage from "../pages/docs/component/NavPage";
import NavbarPage from "../pages/docs/component/NavbarPage";
import ProgressPage from "../pages/docs/component/ProgressPage";
import SpinnerPage from "../pages/docs/component/SpinnerPage";
import OffcanvasPage from "../pages/docs/component/OffcanvasPage";
import PaginationPage from "../pages/docs/component/PaginationPage";
import TooltipPage from "../pages/docs/component/TooltipPage";
import PopoverPage from "../pages/docs/component/PopoverPage";
import ToastPage from "../pages/docs/component/ToastPage";
import DataTablePage from "../pages/docs/content/DataTablePage";
import TablePage from "../pages/docs/content/TablePage";
import TypographyPage from "../pages/docs/content/TypographyPage";
import ImagePage from "../pages/docs/content/ImagePage";
import IconsPage from "../pages/docs/content/IconsPage";
import DocLayout from "../pages/docs/DocLayout";
import RootLayout from "../pages/RootLayout";
import Home from "../pages/Home";
import OverviewPage from "../pages/docs/form/OverviewPage";
import FormControlPage from "../pages/docs/form/FormControlPage";
import SelectPage from "../pages/docs/form/SelectPage";
import ChecksRadiosPage from "../pages/docs/form/ChecksRadiosPage";
import RangePage from "../pages/docs/form/RangePage";
import ValidationPage from "../pages/docs/form/ValidationPage";
import InputGroupPage from "../pages/docs/form/InputGroupPage";
import HtmlEditorPage from "../pages/docs/form/HtmlEditorPage";



export const routes = [
    {
        path: "/",
        element: <RootLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                element: <Home />
            },
        ]
    },
    {
        path: "/docs",
        element: <DocLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                element: <Navigate to="get-started" replace />
            },
            {
                path: "get-started",
                element: <GetStartedPage />
            },
            {
                path: "layout",
                children: [
                    {
                        index: true,
                        element: <Navigate to="structure" replace />
                    },
                    {
                        path: "structure",
                        element: <LayoutStructurePage />
                    },
                    {
                        path: "stack",
                        element: <StackPage />
                    },
                    {
                        path: "container",
                        element: <ContainerPage />
                    },
                    {
                        path: "grid",
                        element: <GridPage />
                    }
                ]
            },
            {
                path: "content",
                children: [
                    {
                        index: true,
                        element: <Navigate to="typography" replace />
                    },
                    {
                        path: "typography",
                        element: <TypographyPage />
                    },
                    {
                        path: "icons",
                        element: <IconsPage />
                    },
                    {
                        path: "image",
                        element: <ImagePage />
                    },
                    {
                        path: "data-table",
                        element: <DataTablePage />
                    },
                    {
                        path: "table",
                        element: <TablePage />
                    }
                ]
            },
            {
                path: "forms",
                children: [
                    {
                        index: true,
                        element: <OverviewPage />
                    },
                    {
                        path: "form-control",
                        element: <FormControlPage />
                    },
                    {
                        path: "select",
                        element: <SelectPage />
                    },
                    {
                        path: "checks-radios",
                        element: <ChecksRadiosPage />
                    },
                    {
                        path: "range",
                        element: <RangePage />
                    },
                    {
                        path: "input-group",
                        element: <InputGroupPage />
                    },
                    {
                        path: "validation",
                        element: <ValidationPage />
                    },
                    {
                        path: "html-editor",
                        element: <HtmlEditorPage />
                    },
                ]
            },
            {
                path: "components",
                children: [
                    {
                        index: true,
                        element: <Navigate to="accordion" replace />
                    },
                    {
                        path: "accordion",
                        element: <AccordionPage />
                    },
                    {
                        path: "alert",
                        element: <AlertPage />
                    },
                    {
                        path: "badge",
                        element: <BadgePage />
                    },
                    {
                        path: "listgroup",
                        element: <ListGroupPage />
                    },
                    {
                        path: "breadcrumb",
                        element: <BreadcrumbPage />
                    },
                    {
                        path: "button",
                        element: <ButtonPage />
                    },
                    {
                        path: "buttongroup",
                        element: <ButtonGroupPage />
                    },
                    {
                        path: "card",
                        element: <CardPage />
                    },
                    {
                        path: "dropdown",
                        element: <DropdownPage />
                    },
                    {
                        path: "modal",
                        element: <ModalPage />
                    },
                    {
                        path: "nav",
                        element: <NavPage />
                    },
                    {
                        path: "navbar",
                        element: <NavbarPage />
                    },
                    {
                        path: "progress",
                        element: <ProgressPage />
                    },
                    {
                        path: "spinner",
                        element: <SpinnerPage />
                    },
                    {
                        path: "offcanvas",
                        element: <OffcanvasPage />
                    },
                    {
                        path: "pagination",
                        element: <PaginationPage />
                    },
                    {
                        path: "tooltip",
                        element: <TooltipPage />
                    },
                    {
                        path: "popover",
                        element: <PopoverPage />
                    },
                    {
                        path: "toast",
                        element: <ToastPage />
                    },
                ]
            },
        ]
    }
];
